import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      pageOgTitle: "상조회사 알아보기, 선불제? 후불제?  - [우리가 찾던 장례전문가, 고이]",
      pageDescription:
        "어떤 차이가 있는지 장단점은 무엇인지 나에게 맞는 서비스는 무엇인지 알려드리겠습니다.",
      pageKeywords:
        "후불제, 후불제상조, 선불제, 선불제상조, 후불제 선불제 차이, 후불제상조 선불제상조, 후불제 선불제, 선불제 가입, 후불상조, 선불상조, 상조, 상조 장단점, 후불제 장단점, 선불제 장단점, 상조결합상품, 상조가입, 상조비교, 장례상조, 홈쇼핑상조, 상조보험추천, 상조회사추천",
      pageOgDescription:
        "선불제와 후불제 상조가 있다는 거 알고 계셨나요? 어떤 차이가 있는지 장단점은 무엇인지 나에게 맞는 서비스는 무엇인지 알려드리겠습니다.",
      pageOgImage: `${process.env.NEXT_PUBLIC_CDN_URL}/platform/prepare/prepare-2-1.png`,
    },
  };
};

export { PrepareSecondContainer as default } from "containers/FuneralPrepareContainer";
